import { createTheme } from '@mui/material/styles';

/**
 * Canonical Alpaca Intelligence theme — tokens extracted verbatim from
 * docs/02-Technical-Documentation/UI-Designs/00-design-system.md Section 2.
 * Do NOT invent colors here; every value traces to the mockups.
 */
export const brand = {
  orange: '#e8670a',
  orangeHover: '#d45e09',
  orangeSoft: '#ff8c42',
  orangeSoftHover: '#e8722a',
  orangeDark: '#c45a08',
  orangeTint: '#fff3ec',
  orangeHighlight: '#f07a30',
  railNavy: '#171727',    // BO UI Standard §3 (was #1a1a2e) — mirrors --ai-rail-navy
  surfacePage: '#eef0f4', // BO UI Standard (was #f3f2f1) — mirrors --ai-bg
  surfaceCard: '#ffffff',
  borderDefault: '#e5e5e5',
} as const;

export const badgeTokens = {
  intel: { bg: '#fff3ec', text: '#c45a08' },
  view: { bg: '#f3f2f1', text: '#888888' },
  new: { bg: '#E1F5EE', text: '#0F6E56' },
  ai: { bg: '#EEEDFE', text: '#534AB7' },
} as const;

export const layout = {
  railWidth: 52,
  sidebarWidth: 240,
  topbarHeight: 48,
} as const;

export const alpacaTheme = createTheme({
  palette: {
    primary: { main: '#e8670a', dark: '#d45e09', light: '#ff8c42', contrastText: '#fff' },
    secondary: { main: '#171727', contrastText: '#fff' },
    background: { default: '#eef0f4', paper: '#ffffff' },
    text: { primary: '#111', secondary: '#555', disabled: '#ccc' },
    divider: '#e5e5e5',
    error: { main: '#9F1239' },
    warning: { main: '#D97706' },
    success: { main: '#0F6E56' },
    info: { main: '#185FA5' },
  },
  shape: { borderRadius: 8 },
  typography: {
    // BO UI Standard §1 (V3, decision 2026-07-06): Segoe UI FIRST to match the
    // legacy ALPACA LIMS (DevExpress/XAF) face. Never lead with Public Sans.
    // Mirrors --ai-font in theme/tokens.css. Base size 13px everywhere.
    fontFamily: '"Segoe UI", Tahoma, system-ui, -apple-system, Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSize: 13,
  },
});
